import { appItem, featureItems, cardItems } from '@/mocks/home';

export function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/70">
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 rounded-xl overflow-hidden">
              <img
                src={appItem.qrcode}
                alt="桔子视频移动端入口"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const t = e.currentTarget;
                  t.style.display = 'none';
                  if (t.parentElement) t.parentElement.style.display = 'none';
                }}
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
              {appItem.title}
            </h2>
            <p className="text-sm text-foreground-500 mb-5">{appItem.subtitle}</p>
            <div className="grid grid-cols-2 gap-3">
              {appItem.features.map((f) => (
                <div key={f} className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-primary-500">
                    <i className="ri-checkbox-circle-fill text-sm"></i>
                  </div>
                  <span className="whitespace-nowrap">{f}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为什么选择桔子视频观看高清在线内容
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="flex flex-col items-center text-center p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          专题推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精选优质内容专题，发现更多你喜欢的影视作品
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <div
              key={item.title}
              className="rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const t = e.currentTarget;
                    t.style.display = 'none';
                    if (t.parentElement) t.parentElement.style.display = 'none';
                  }}
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium flex-shrink-0 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}